import { atom, useAtom } from 'jotai'

export interface BanInfo {
  begin_at: number
  created_at: number
  duration: number
  duration_text: string
  end_at: number
  id: number
  operator_id: number
  reason: string
  type: number
  type_text: string
  user_id: number
}

export const isBanModalVisible = atom(false)
isBanModalVisible.debugLabel = 'isBanModalVisible'

export const banInfoAtom = atom<BanInfo[]>([])
banInfoAtom.debugLabel = 'banInfoAtom'

export const useBanModalAtom = () => {
  const [isBanVisible, setIsBanVisible] = useAtom(isBanModalVisible)
  const [banInfo, setBanInfo] = useAtom(banInfoAtom)

  return {
    isBanVisible,
    setIsBanVisible,
    banInfo,
    setBanInfo,
  }
}
